import { ContextMenuItemView } from '@mark43/cad-api';
import { ContextMenuItem } from '../context-menus/components/context-menu-item';
import { useViewLocationOnMap } from '../location/hooks/use-view-location-on-map';
import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';
import { EsriMapEntityTypeEnum } from '../esri/types';

export function ViewHospitalOnMapItem({
    hospitalId,
    viewOnMapContextMenuItemView,
}: {
    hospitalId: number;
    viewOnMapContextMenuItemView: ContextMenuItemView;
}) {
    const { disableLegacyMapAndSearches, mapWindowEnabled } = useEnabledFeatures();
    const viewLocationOnMap = useViewLocationOnMap();
    function handleSelect() {
        if (disableLegacyMapAndSearches || mapWindowEnabled) {
            viewLocationOnMap({
                entityId: hospitalId,
                entityType: EsriMapEntityTypeEnum.HOSPITAL,
                doNotFocus: false,
            });
        }
    }
    return (
        <ContextMenuItem
            contextMenuItemView={viewOnMapContextMenuItemView}
            onSelect={handleSelect}
        />
    );
}
